import React from "react";
import Header from "./Header";

function About() {
    return (
        <div className="container">
            <Header />
            <div className="about">
                <p>
                    Cette Progressive Web App a été développée par Loic GUINLE à l’occasion de son stage dans la société Enyoko.<br /> <br/>
                    Pour toute demande  / remarque écrire à : guillaume@enyoko.fr – SPV RAD SDIS 32. <br /> <br/>
                    Remerciements pour leur contribution à :                
                </p>
                <ul>
                    <li>ADC Jean Christophe MERCIER -  SDIS 32</li>
                    <li>LTN Laurent RIERA -  SDIS 32 </li>
                    <li>SGC Sandrine ROUZAUD -  SDIS 32</li>
                </ul>

                </div>
                
            </div>
            )
}

            export default About;